import { Link, useLocation } from "react-router-dom";
import useAuthStore from "../../store/AuthStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faStore,
  faTachometerAlt,
  faUser,
  faSignInAlt,
  faBlog,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";

const BottomNav = () => {
  const { user } = useAuthStore();
  const location = useLocation();

  const links = user
    ? [
        { to: "/", label: "Home", icon: faHome },
        { to: "/assets", label: "Mart", icon: faStore },
        { to: "/user/my-dashboard", label: "Dashboard", icon: faTachometerAlt },
        { to: "/user/my-dashboard/profile", label: "Profile", icon: faUser },
        { to:"/insights", label:"Insights", icon:faBlog},
      ]
      : [
        { to: "/", label: "Home", icon: faHome },
        { to: "/assets", label: "Mart", icon: faStore },
        { to: "/sign-up", label: "Join", icon: faUserPlus },
        { to: "/login", label: "Login", icon: faSignInAlt },
        { to:"/insights", label:"Insights", icon:faBlog},
      ];

  return (
    <nav className="fixed md:hidden bottom-0 left-0 right-0 bg-white border-t border-gray-100 flex justify-around items-center h-16 z-50 px-2 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]">
      {links.map((link) => {
        // Simple exact match or check if sub-route is active
        const isActive = location.pathname === link.to;

        return (
          <Link
            key={link.to}
            to={link.to}
            className="relative flex flex-col items-center justify-center w-full h-full transition-all duration-300"
          >
            {/* Active Indicator Background */}
            <div
              className={`flex flex-col items-center justify-center transition-all duration-300 ${
                isActive ? "-translate-y-1" : "translate-y-0"
              }`}
            >
              <div
                className={`flex items-center justify-center w-10 h-10 rounded-2xl transition-all duration-300 ${
                  isActive
                    ? "bg-blue-600 text-white shadow-lg shadow-blue-200"
                    : "bg-transparent text-gray-400"
                }`}
              >
                <FontAwesomeIcon icon={link.icon} className="text-lg" />
              </div>

              <span
                className={`text-[10px] mt-1 font-medium transition-colors duration-300 ${
                  isActive ? "text-blue-600 font-bold" : "text-gray-400"
                }`}
              >
                {link.label}
              </span>
            </div>

            {/* Subtle bottom dot for active state */}
            {isActive && (
              <div className="absolute bottom-1 w-1 h-1 bg-blue-600 rounded-full" />
            )}
          </Link>
        );
      })}
    </nav>
  );
};

export default BottomNav;
